export const config = {
  title: "iSmart Wash | Professional Car Detailing & Wash in Cincinnati, OH",
  meta: {
    description:
      "iSmart Wash offers high-quality car detailing and wash services in Cincinnati, OH, specializing in full-service hand washing, interior deep cleaning, and ceramic coatings.",
    keywords: [
      'Car Wash Cincinnati OH',
      'Auto Detailing',
      'Mobile Car Wash',
      'Interior Car Cleaning',
      'Ceramic Coating',
      'Hand Wash Service',
      'Paint Protection',
      'Car Polishing',
      'Car Waxing',
      'iSmart Wash'
    ],
    author: "iSmart Wash",
    canonicalUrl: 'https://www.ismartcardetailing.com/',
  },
  sections: {
    header: {
      businessName: "iSmart Wash",
    },
    sectionB: {
      heroTitle: "iSmart Wash",
      heroSubtitle: 'Premium Car Detailing & Wash Services in Cincinnati, OH',
      learnAboutText: 'Discover Our Car Detailing Services',
      phoneNumber: '5133241495',
      phoneLabel: '(513) 324-1495',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2096432758/photo/cleaning-the-car-interior-with-a-brush-a-car-detailing-worker-cleaning-the-interior-of-a-car.jpg?s=612x612&w=0&k=20&c=2N91bv5B6YLkAw7YXrJ_NwHJnaUVLQkUfWBYimvoWhY=",
      cardData: [
        {
          title: 'Eco-Friendly Car Wash',
          description: 'Using biodegradable products to clean and protect your car while caring for the environment.',
        },
        {
          title: 'Mobile & In-Shop Services',
          description: 'Convenience at its best—choose between our shop or mobile detailing services at your location.',
        },
        {
          title: 'Superior Protection',
          description: 'We offer ceramic coatings, waxing, and paint protection to keep your car looking brand new.',
        },
      ],
      description:
        "iSmart Wash specializes in high-quality car detailing and wash services, including interior and exterior cleaning, ceramic coatings, and mobile detailing in Cincinnati, OH. Our team ensures every vehicle leaves our shop with a showroom-quality shine.",
    },
    sectionC: {
      servicesTitle: 'Our Car Detailing Services',
      servicesDescription:
        "Explore our professional car detailing and wash services designed to give your vehicle a pristine look.",
      cards: [
        {
          title: 'Full Interior & Exterior Detailing',
          description:
            'A complete deep clean for both inside and outside your vehicle, restoring it to a like-new condition.',
          imageSrc: 'https://media.istockphoto.com/id/1220576793/photo/car-detailing-steam-cleaning-concept-handsome-man-in-black-t-shirt-and-cap-worker-of-car-wash.jpg?s=612x612&w=0&k=20&c=dy-tKqaAi141bLtHPz7sdqnve4euPzxo0DHrLZrq32E=',
          imageAlt: 'Full Interior & Exterior Detailing',
        },
        {
          title: 'Hand Wash & Wax',
          description:
            'Gentle hand wash with premium wax protection to keep your car looking polished and protected.',
          imageSrc: 'https://media.istockphoto.com/id/1218956980/photo/hand-is-cleaning-car-headlight-with-a-using-red-microfiber-cloth.jpg?s=612x612&w=0&k=20&c=s6c0FTNj5Cyg7-qdFR4mzk-u2nvIlyu51tikTUHyjuE=',
          imageAlt: 'Hand Wash & Wax',
        },
        {
          title: 'Ceramic Coating & Paint Protection',
          description:
            'Advanced ceramic coatings and protective sealants to extend the longevity of your car’s paintwork.',
          imageSrc: 'https://media.istockphoto.com/id/1146607309/photo/wipe-the-car-clean.jpg?s=612x612&w=0&k=20&c=bl500Lr-Q4pFZXSG7oQbtqTh5sX8FexnOxuYwe_W278=',
          imageAlt: 'Ceramic Coating & Paint Protection',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Steam Cleaning & Stain Removal',
        'Headlight Restoration',
        'Engine Bay Cleaning',
        'Leather & Upholstery Conditioning',
        'Scratch & Swirl Removal',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1209852296/photo/worker-of-the-detailing-center-polishes-car-body.jpg?s=612x612&w=0&k=20&c=om__Tb8Cw1xiIzBDHFBLlNu3NuCSu08voVrrEKnUG6w=',
        alt: "iSmart Wash Team",
      },
      aboutText: [
        "iSmart Wash is a professional car detailing company in Cincinnati, OH, dedicated to providing high-quality, eco-friendly cleaning solutions.",
        "We offer a range of services, from basic hand washes to full ceramic coatings, to ensure that every vehicle gets the best care possible. Our team is committed to providing top-notch detailing services that leave your car looking pristine and protected.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "iSmart Wash Logo",
      businessName: "iSmart Wash",
      contact: {
        phone: '5133241495',
        phoneLabel: '(513) 324-1495',
        email: 'ismartcardetailing@yahoo.com',
        website: 'https://www.ismartcardetailing.com/',
        address: '6702 River Rd Cincinnati, OH 45233, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: '6702 River Rd Cincinnati, OH 45233, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d-84.653488!3d39.099728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8841b180c3b6b1b9%3A0x7fcef73ff3b1e0c3!2s6702%20River%20Rd%2C%20Cincinnati%2C%20OH%2045233%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
